import { makeStyles } from '@material-ui/core';

const useStyles = (a: any) =>
  makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(a),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
  }));

export default useStyles;
